module.exports = __webpack_public_path__ + "static/media/sort-shapes-up-alt.05c70b11.svg";